import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router";
import SideBar from "components/common/SideBar/SideBarNew";
import Header from "components/common/Header/Header";
import { LoginContext } from "helpers/LoginContext";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import { roleAccess, usePermissionsVersion } from "helpers/RolesPermission";
import WelcomeBanner from "pages/SupportCoordination/Participant/Dashboard/partials/dashboard/WelcomeBanner";
import { FiFilePlus, FiFileText, FiSettings } from "react-icons/fi";
import DashboardModuleCard from "../components/DashboardModuleCard";

const InvoicingDashboard = () => {
  const { sideBarPadding } = useContext(LoginContext);
  const navigate = useNavigate();
  const permissionsVersion = usePermissionsVersion();

  const cards = useMemo(
    () =>
      [
        {
          name: "Code Allocation",
          role: "All Shift Codes Allocated",
          href: "rostering/invoicing/allocation",
          icon: FiSettings,
          iconVariant: "blue",
          permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.ALLOCATION,
        },
        {
          name: "Create Invoice",
          role: "All Shifts Ready For Invoices",
          href: "rostering/create-roster-invoice",
          icon: FiFilePlus,
          iconVariant: "teal",
          permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
        },
        {
          name: "Invoices",
          role: "All Created Invoices",
          href: "rostering/invoicing",
          icon: FiFileText,
          iconVariant: "brand",
          permissionChild: PERMISSION_KEYS_CHILDREN.ROSTER_INVOICE.CREATE,
        },
      ].filter((x) =>
        roleAccess([], PERMISSION_KEYS.ROSTER_INVOICE, x.permissionChild)
      ),
    [permissionsVersion]
  );

  return (
    <div className='min-h-full'>
      <SideBar />
      <div
        className={`duration-300 flex flex-col ${
          sideBarPadding ? "lg:pl-[4rem]" : "lg:pl-64"
        }`}
      >
        <main className='flex-1 relative'>
          <Header title='Invoicing Dashboard' />
          <div className='min-full'>
            <div className='w-full space-y-6 py-8 sm:px-6 lg:px-8'>
              <WelcomeBanner />

              <div className='invoicing-workflow-page rounded-lg bg-gray-50 p-4 md:p-6'>
                <div className='iw-stats !m-0 !grid-cols-1 sm:!grid-cols-2 lg:!grid-cols-3'>
                  {cards.map((card) => (
                    <DashboardModuleCard
                      key={card.name}
                      icon={card.icon}
                      name={card.name}
                      description={card.role}
                      value='→'
                      iconVariant={card.iconVariant}
                      onClick={() => navigate(`/${card.href}`)}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default InvoicingDashboard;
